module.exports = __webpack_public_path__ + "21461d48c982e04b258b2a660dfc03b5.pdf";